module.exports = __webpack_public_path__ + "static/media/V-img8.0abaa03b.png";